import * as Yup from 'yup'

export const sellerFormSchema = () => {
  let sellerFormSchema =  Yup.object().shape({
    seller: Yup.object({
      username: Yup.string()
        .min(2, 'At least 2 characters')
        .required('Required'),

      name: Yup.string()
        .min(2, 'At least 2 characters')
        .required('Required'),

      gender: Yup.string()
        .required('Required'),

      referrer: Yup.string()
        .required('Required'),

      birthday: Yup.string()
        .required('Required'),

      email: Yup.string()
        .min(2, 'At least 2 characters')
        .email('Invalid email')
        .required('Required'),

      mobile: Yup.string()
        .min(10, 'At least 10 digits')
        .matches(/^(^62)(\d{3,4}-?){2}\d{3,4}$/, 'Please input a valid mobile number, starting with 62')
        .required('Required'),

      seller_type: Yup.string()
        .required('Required'),

      contract_id: Yup.string()
        .required('Required'),


      bank: Yup.string()
        .required('Required'),

      bank_branch: Yup.string()
        .required('Required'),

      account_number: Yup.string()
        .required('Required'),

      account_name: Yup.string()
        .required('Required')
    })
  })

  return sellerFormSchema
}

export const userCreateFormSchema = (isAddSeller) => {
  let userCreateFormSchema = Yup.object().shape({
    name: Yup.string()
      .matches(/^[a-zA-Z\s]*$/, 'Only letters allowed')
      .min(2, 'At least 2 characters')
      .required('Required'),
    email: Yup.string()
      .min(2, 'At least 2 characters')
      .email('Invalid email')
      .required('Required'),
    mobile: Yup.string()
      .min(10, 'At least 10 digits')
      .max(13, 'Maximal 13 digits') // since using 62 in backend validation
      .matches(/^(^62)(\d{3,4}-?){2}\d{3,4}$/, 'Please input a valid mobile number, starting with 62')
      .required('Required'),
    birthday: Yup.date()
      .required('Required'),
    gender: Yup.string()
      .required('Required'),
    customer_type: Yup.string()
      .required('Required'),
    sign_up_affiliate_name: Yup.string()
      .required('Required'),
    verification_method: Yup.string()
      .when('is_verified', {
        is   : true,
        then : Yup.string().required('Required')
      }),

    user_address: Yup.object().shape({
      street_address     : Yup.string().required('Cannot be blank'),
      tl_province_id     : Yup.string().required('Cannot be blank'),
      tl_city_id         : Yup.string().required('Cannot be blank'),
      tl_district_id     : Yup.string().required('Cannot be blank'),
      tl_sub_district_id : Yup.string().required('Cannot be blank'),
      postal_code        : Yup.string().required('Cannot be blank')
    })

  })

  if (isAddSeller) {
    userCreateFormSchema = userCreateFormSchema.concat( sellerFormSchema() )
  }

  return userCreateFormSchema
}
